import React, { Component } from 'react';

//import {CSVDownload} from 'react-csv';

import 'react-day-picker/lib/style.css';

import '../DailyReport/DailyReport.css';

import 'tachyons';



class Allergy extends Component {
  constructor(props){
    super(props);
    this.state = {

      data:[],
      ddata:false,
      csvList:[],
     schoolList:[],
     showclasses:false,
     showdates:false,
     grades:[],


    }
  }


    async componentDidMount(){
      fetch('https://schoolportal.appsdesign.co.za/get_child/'+ await localStorage.getItem('schoolToken'))
      .then((response) => response.json())
      .then((responseJson) => {
    console.log(responseJson[0])
        this.setState({
          data: responseJson,

    }, function(){

        });
  console.log(this.state.data)
      })

      .catch((error) =>{
        console.error(error);
      });


      }







  render() {


    const listView = this.state.data.map((item,i) =>{
if(item.allergies.length > 0){
    return(
    <tr key={i}>

    <td>{item.childsurname}</td>
    <td>{item.childname}</td>
    <td>{item.childclass}</td>
    <td>{item.allergies.join(',')}</td>



    </tr>

    )
}else{
  return null
}
    })


    return (
    <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
    <h1>Allergies</h1>

    <table style={{ margin:10}}>
 <tbody>
    <tr>
  <th>Child Surname</th><th>Child Name</th><th>Class</th><th>Allergies</th>
    </tr>
  {listView}
     </tbody>
    </table>
    </div>






    );
  }
}

export default Allergy;



// WEBPACK FOOTER //
// ./src/components/Allergy/Allergy.js